module.exports = __webpack_public_path__ + "static/media/hero-2.77b2a199.jpg";